import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import useStyles from '../useStyles';
import styles from './styles';

const Status = (props) => {
  const { state, children } = props;
  const classes = useStyles(styles);
  let currentState;
  let _state;

  if (typeof state === 'string') {
    _state = state;
  } else if (typeof state === 'function') {
    _state = useSelector(state);
  }

  if (!_state) return '';

  if (children.constructor === Array) {
    currentState = children.find((child) => child.props[_state] === true);
  } else {
    currentState = children;
  }

  if (!currentState) return '';

  return <div className={classes.container}>{currentState}</div>;
};
Status.defaultProps = {
  state: '',
};
Status.propTypes = {
  state: PropTypes.oneOfType([
    PropTypes.oneOf(['error', 'loading', 'success']),
    PropTypes.func,
  ]),
};

export default Status;
